<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="contacts" /> Group app
        </span>

        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add
        </a-button>
      </div>
      <a-table
        class="top-table"
        :columns="columnsAppInPlatformGroup"
        :data-source="AppInPlatformGroups"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <a
          slot="titleType"
          slot-scope="text, record"
          @click="collapseVisibleDetail(record.id)"
        >
          {{ text }}
        </a>
        <a slot="no" slot-scope="text, record, index">
          {{ index + 1 }}
        </a>

        <span slot="author" slot-scope="text">
          {{ text.author && (text.author.fullname || text.author.username) }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="price" slot-scope="text">
          {{ text | currency }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
      </a-table>
    </a-card>

    <a-drawer
      v-if="visibleEdit"
      title="Edit"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditAppInPlatformGroup
        :idAppInPlatformGroup="idAppInPlatformGroup"
        :close="() => (visibleEdit = false)"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
        :selectedGroup="selectedGroup"
      />
    </a-drawer>

    <a-drawer
      v-if="visibleAdd"
      title="Add"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddAppInPlatformGroup
        :close="() => (visibleAdd = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
  </div>
</template>
<script>
import { columnsAppInPlatformGroup } from "@/views/configAdmin/appInPlatformGroup/constant/column";
import query from "@/views/configAdmin/appInPlatformGroup/constant/query";
import AddAppInPlatformGroup from "./components/addAppInPlatformGroup";
import EditAppInPlatformGroup from "./components/editAppInPlatformGroup";
import debouce from "lodash/debounce";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

export default {
  components: { AddAppInPlatformGroup, EditAppInPlatformGroup },
  data() {
    this.onFilter = debouce(this.onFilter, 500);
    return {
      keySearch: "",
      visibleEdit: false,
      isPagination: true,
      visibleAdd: false,
      columnsAppInPlatformGroup,
      loadingList: true,
      AppInPlatformGroups: [],
      idAppInPlatformGroup: "",
      limit,
      currentPage: startPage,
      filter: {},
      totalPage: startPage,
      selectedGroup: undefined,
    };
  },
  methods: {
    onGetAppInPlatformGroup(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllAppInPlatformGroup,
          fetchPolicy: "no-cache",
          variables: {},
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (flag === "PAGINATION") {
            if (
              data.getAllAppInPlatformGroup?.length >= 0 &&
              this.AppInPlatformGroups?.length >= 0
            ) {
              this.AppInPlatformGroups = this.AppInPlatformGroups.concat([
                ...data.getAllAppInPlatformGroup,
              ]);
            } else {
              this.AppInPlatformGroups = [...data.getAllAppInPlatformGroup];
            }
          } else {
            if (data?.getAllAppInPlatformGroup?.length >= 0) {
              this.AppInPlatformGroups = [...data.getAllAppInPlatformGroup];
            }
          }

          // check is pagniation
          if (data.getAllAppInPlatformGroup.length < limit) {
            this.isPagination = false;
          } else {
            this.isPagination = true;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get info error!",
          });
          console.error("Lấy danh sách khách hàng không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idAppInPlatformGroup = id;
        this.visibleDetail = true;
      } else {
        this.idAppInPlatformGroup = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(record) {
      if (record) {
        this.selectedGroup = record;
        this.visibleEdit = true;
      } else {
        this.idAppInPlatformGroup = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.totalPage = startPage;
      this.currentPage = startPage;
      this.onGetAppInPlatformGroup("FILTER");
    },
    refreshAfterUpdated(item) {
      this.AppInPlatformGroups = updateForUpdated(
        this.AppInPlatformGroups,
        item
      );
    },
    refreshAfterDeleted(item) {
      this.AppInPlatformGroups = updateForDeleted(
        this.AppInPlatformGroups,
        item
      );
    },
    refreshAfterCreated(item) {
      this.AppInPlatformGroups = updateForCreated({
        list: this.AppInPlatformGroups,
        item,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAppInPlatformGroup("PAGINATION");
      }
    },
  },
  created() {
    this.onGetAppInPlatformGroup();
  },
};
</script>
